import useAPI from '@/hooks/useAPI';
import ProgramRepository from '@/repositories/ProgramRepository';

export const useDisqualificationReasons = (enabled = true) => {
  const programRepository = ProgramRepository();

  return useAPI({
    queryKey: ['getDisqualificationReasons'],
    queryFn: async () => {
      return await programRepository.getDisqualificationReasons();
    },
    enabled
  });
};

export default useDisqualificationReasons;
